import Image, { ImageLoaderProps } from 'next/legacy/image'
import React, { useMemo } from 'react'
import styled from 'styled-components'
// import { toTransparentBg } from '~/utils'

const StyledMyImage = styled.div<{
  editable: boolean
}>`
  position: relative;
  overflow: hidden;
  cursor: ${props => (props.editable ? 'pointer' : 'inherit')};
`

/**
 * tag说明
 * v400 表示就改图片质量为75且宽度为400
 * v800 表示就改图片质量为75且宽度为800
 * v1200 表示就改图片质量为75且宽度为1200
 * v2400 表示就改图片质量为75且宽度为2400
 * **/

export const MyImage: React.FC<{
  src: string | null | undefined
  className?: string
  style?: React.CSSProperties
  quality?: number
  alt?: string
  lazy?: boolean
  tag?: 'v400' | 'v800' | 'v1200' | 'v2400'
  onClick?: () => void
  dark?: boolean
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
}> = ({
  src,
  className,
  style,
  quality = 75,
  alt = '',
  lazy = true,
  onClick,
  tag,
  dark = false,
  objectFit = 'cover',
}) => {
  // 七牛的图片处理API
  // https://developer.qiniu.com/dora/1279/basic-processing-images-imageview2
  const myLoader = ({ src, quality }: ImageLoaderProps) => {
    return tag
      ? `${src}?imageView2/2/w/${tag.replace('v', '')}/q/${quality}/format/webp`
      : `${src}?imageView2/2/q/${quality}/format/webp`
  }

  const defaultSrc = useMemo(() => {
    return !!dark ? '/images/placeholder-dark.png' : '/images/placeholder.png'
  }, [dark])

  return (
    <StyledMyImage
      className={className}
      style={{
        ...style,
        // ...toTransparentBg({ imgUrl: src }),
      }}
      onClick={onClick}
      editable={!!onClick}
    >
      <Image
        src={src || defaultSrc}
        placeholder="blur"
        blurDataURL={defaultSrc}
        // lazyBoundary="0px"
        loading={lazy ? 'lazy' : 'eager'}
        layout="fill"
        objectFit={objectFit}
        quality={quality}
        loader={myLoader}
        alt={alt}
      />
    </StyledMyImage>
  )
}
